import { Component, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { CardConfig } from '../../models/mobile-table';
import { getVar } from '../../Utils/css';
import { TableEvent } from '../table/Itable';
import { CurrencySymbolPipe } from '../../Utils/currency-simbol-pipe';

@Component({
  selector: 'app-mobile-card-list',
  templateUrl: './mobile-card-list.component.html',
  styleUrls: ['./mobile-card-list.component.scss']
})
export class MobileCardListComponent {
  @Input() data: any[] = [];
  @Input() config!: CardConfig;
  @Input() showNoData: boolean = false;
  @Output() cardAction = new EventEmitter<any>();
  @Output() action: EventEmitter<TableEvent> = new EventEmitter<TableEvent>();
  
  @Input() isForSelectItem?: boolean;
  @Output() selectedItemsChange = new EventEmitter<any>();
  @Output() selectedAllItems = new EventEmitter<boolean>();
  @Input() set clearSelection(value: boolean) {
    if (value) {
      this.clearSelectedItems();
    }
  }
  @Input() getRowId?: (item: any) => string;
  @Input() selectAllChecked = false;
  selectedItems: Set<any> = new Set();
  selectSomeChecked = false;

  showMenuForItem: any = null;

  menuColor = getVar('--global-secondary-color');

  constructor(
    private currencySymbolPipe: CurrencySymbolPipe,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {  
      if (changes['selectAllChecked'] && !changes['selectAllChecked'].firstChange) {
        this.showSelectAllChecked();
        this.cdr.markForCheck();
      }
    }

  toggleMenu(item: any): void {
    this.showMenuForItem = this.showMenuForItem === item ? null : item;
  }

  onCardAction(item: any, action: string): void {
    this.showMenuForItem = null; 
    if (this.config?.actions && this.config.actions.length > 0) {
      this.cardAction.emit({ item, action });
      this.action.emit({ event: action, dataField: item });
    } else {
      this.cardAction.emit(item);
    }
  }

  isActionDisabled(item: any, action: string): boolean {
    return this.config?.isActionDisabled 
      ? this.config.isActionDisabled(item, action) 
      : false;
  }

  getCurrencySymbol(currencyCode: string): string {
    return this.currencySymbolPipe.transform(currencyCode);
  }

  toggleSelectAllItems() {
    this.selectAllChecked = !this.selectAllChecked;
    this.selectedAllItems.emit(this.selectAllChecked)
    this.showSelectAllChecked();
  }

  showSelectAllChecked() {
    this.selectedItems.clear();
    if (this.selectAllChecked) {
      this.data.forEach((item: any) => {
        const itemId = this.getRowId ? this.getRowId(item) : item;
        this.selectedItems.add(itemId);
      });
      this.selectedItemsChange.emit(Array.from(this.selectedItems));
    } else {
      this.selectSomeChecked = false;
      this.selectedItemsChange.emit(Array.from(this.selectedItems));
    }
  }

  toggleItemSelection(item: any) {
    const itemId = this.getRowId ? this.getRowId(item) : item;
    if (this.selectedItems.has(itemId)) {
      this.selectedItems.delete(itemId);
      this.selectedItemsChange.emit(Array.from(this.selectedItems));
    } else {
      this.selectedItems.add(itemId);
      this.selectedItemsChange.emit(Array.from(this.selectedItems));
    }
    this.selectAllChecked = this.selectedItems.size == this.data.length
    this.selectSomeChecked = this.selectedItems.size > 0
    this.selectedAllItems.emit(this.selectAllChecked)
  }

  isItemSelected(item: any): boolean {
    const itemId = this.getRowId ? this.getRowId(item) : item;
    return this.selectedItems.has(itemId);
  }

  clearSelectedItems() {
    this.selectedItems.clear();
    this.selectAllChecked = false;
    this.selectSomeChecked = false;
    this.selectedItemsChange.emit(Array.from(this.selectedItems));
  }
}
export { CardConfig };

